import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import JotformHeroSection from '@/components/jotform/JotformHeroSection';
import JotformExpertiseSection from '@/components/jotform/JotformExpertiseSection';
import JotformServicesSection from '@/components/jotform/JotformServicesSection';
import JotformPortfolioSection from '@/components/jotform/JotformPortfolioSection';
import JotformTestimonialsSection from '@/components/jotform/JotformTestimonialsSection';
import JotformPricingCalculator from '@/components/jotform/JotformPricingCalculator';
import JotformWhyChooseSection from '@/components/jotform/JotformWhyChooseSection';
import JotformFAQSection from '@/components/jotform/JotformFAQSection';
import JotformCTASection from '@/components/jotform/JotformCTASection';
import JotformStructuredData from '@/components/jotform/JotformStructuredData';

const JotformExpert = () => {
  if (import.meta.env.DEV) {
    console.log('JotformExpert page rendering');
  }
  const { t } = useTranslation('jotform');

  return (
    <div className="min-h-screen">
      <SEOHead page="jotform-expert" />
      <JotformStructuredData />
      <Header />
      <main>
        <JotformHeroSection />
        <JotformExpertiseSection />
        <JotformServicesSection />
        <JotformPortfolioSection />
        <JotformTestimonialsSection />
        <JotformPricingCalculator />
        <JotformWhyChooseSection />
        <JotformFAQSection />
        <JotformCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default JotformExpert;